export const BOOK_MODAL = 'bm';
export const CALL_INSURANCE_MODAL = 'call-insurance-modal';
export const COPAY_COINSURANCE_DETAILS_MODAL = 'copay-coinsurance-details-modal';
export const INSURANCE_TUTORIAL_MODAL = 'insurance-tutorial';
export const WEB_PUSH_OPT_IN_MODAL = 'opt-in';
export const INSURANCE_TUTORIAL_ENTRY_POINT_MODAL = 'insurance-tutorial-entry-point';
